export default __webpack_public_path__ + "static/img_we_3-6cfe087c58fca911eef49f308d5dddb3.png";